var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.markingHandler(_vm.cellData)},[_vm._v(" "+_vm._s(_vm.cellData.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }